export default "__VITE_ASSET__4ffc7c7f__"